import { TOI_LIVE_DOMAIN } from '../../constants';

const breadcrumbs = {
  games: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: '',
    },
  ],
  crossword: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Crossword',
      link: '',
    },
  ],
  crosswordToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Crossword',
      link: `${TOI_LIVE_DOMAIN}/games/crossword`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  crosswordPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Crossword',
      link: `${TOI_LIVE_DOMAIN}/games/crossword`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
  MiniCrossword: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Mini Crossword',
      link: '',
    },
  ],
  MiniCrosswordToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Mini Crossword',
      link: `${TOI_LIVE_DOMAIN}/games/mini-crossword`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  MiniCrosswordPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Mini Crossword',
      link: `${TOI_LIVE_DOMAIN}/games/mini-crossword`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
  sudoku: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Sudoku',
      link: '',
    },
  ],
  sudokuToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Sudoku',
      link: `${TOI_LIVE_DOMAIN}/games/sudoku`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  sudokuPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Sudoku',
      link: `${TOI_LIVE_DOMAIN}/games/sudoku`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
  locationGuesser: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Location Guesser',
      link: '',
    },
  ],
  locationGuesserToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Location Guesser',
      link: `${TOI_LIVE_DOMAIN}/games/location-guesser`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  locationGuesserPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Location Guesser',
      link: `${TOI_LIVE_DOMAIN}/games/location-guesser`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
  loopaloop: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Loop the Loop',
      link: '',
    },
  ],
  loopaloopToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Loop the Loop',
      link: `${TOI_LIVE_DOMAIN}/games/loop-a-loop`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  loopaloopPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: 'Loop the Loop',
      link: `${TOI_LIVE_DOMAIN}/games/loop-a-loop`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
  whosthat: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: "Who's That",
      link: '',
    },
  ],
  whosthatToday: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: "Who's That",
      link: `${TOI_LIVE_DOMAIN}/games/whos-that`,
    },
    {
      label: 'Today',
      link: '',
    },
  ],
  whosthatPractice: [
    {
      label: 'News',
      link: '/',
    },
    {
      label: 'Games',
      link: `${TOI_LIVE_DOMAIN}/games`,
    },
    {
      label: "Who's That",
      link: `${TOI_LIVE_DOMAIN}/games/whos-that`,
    },
    {
      label: 'Practice',
      link: '',
    },
  ],
};

export const getBreadcrumb = breadCrumb => {
  if (breadCrumb) {
    switch (breadCrumb) {
      case 'games':
        return breadcrumbs.games;
      case 'crossword':
        return breadcrumbs.crossword;
      case 'crosswordtoday':
        return breadcrumbs.crosswordToday;
      case 'crosswordpractice':
        return breadcrumbs.crosswordPractice;
      case 'minicrossword':
        return breadcrumbs.MiniCrossword;
      case 'minicrosswordtoday':
        return breadcrumbs.MiniCrosswordToday;
      case 'minicrosswordpractice':
        return breadcrumbs.MiniCrosswordPractice;
      case 'sudoku':
        return breadcrumbs.sudoku;
      case 'sudokutoday':
        return breadcrumbs.sudokuToday;
      case 'sudokupractice':
        return breadcrumbs.sudokuPractice;
      case 'locationguesser':
        return breadcrumbs.locationGuesser;
      case 'locationguessertoday':
        return breadcrumbs.locationGuesserToday;
      case 'locationguesserpractice':
        return breadcrumbs.locationGuesserPractice;
      case 'loopaloop':
        return breadcrumbs.loopaloop;
      case 'loopalooptoday':
        return breadcrumbs.loopaloopToday;
      case 'loopalooppractice':
        return breadcrumbs.loopaloopPractice;
      case 'whosthat':
        return breadcrumbs.whosthat;
      case 'whosthattoday':
        return breadcrumbs.whosthatToday;
      case 'whosthatpractice':
        return breadcrumbs.whosthatPractice;
      default:
        return null;
    }
  }
  return null;
};

export default breadcrumbs;
